<template>
  <model-form
    ref="modelForm"
    :model="userClass"
    modal-type="modal"
  >
    <div class="column">
      <div class="row q-col-gutter-sm items-start">
        <model-form-input
          field="name"
          class="col-6"
          label="Name"
          :rules="[val => !!val || 'Field is required']"
          autofocus
        />
        <model-form-input
          field="description"
          class="col-6"
          label="Description"
        />
      </div>
      <div class="row q-col-gutter-sm items-start">
        <q-toggle
          :model-value="userClass.minAge !== null"
          class="col-6"
          label="Has minimum age"
          bottom-slots
          :disable="userClass.isTranslation"
          @update:model-value="(value) => value ? (userClass.minAge = 0) : (userClass.minAge = null) "
        />
        <model-form-input
          field="minAge"
          type="number"
          min="0"
          max="100"
          class="col-6"
          label="Minimum Age (inclusive in years)"
        />
      </div>
      <div class="row q-col-gutter-sm items-start">
        <q-toggle
          :model-value="userClass.maxAge !== null"
          class="col-6"
          label="Has maximum age"
          bottom-slots
          :disable="userClass.isTranslation"
          @update:model-value="(value) => value ? (userClass.maxAge = 100) : (userClass.maxAge = null) "
        />
        <model-form-input
          field="maxAge"
          type="number"
          min="0"
          max="100"
          class="col-6"
          label="Maximum Age (inclusive in years)"
        />
      </div>
      <div class="row q-col-gutter-sm items-start">
        <model-form-checkbox
          field="availableOnline"
          :disable="userClass.internal"
          class="col-6"
          label="Available Online"
        >
          <q-tooltip>
            With this setting disabled, the user class will only be available at the register.
          </q-tooltip>
        </model-form-checkbox>
        <model-form-checkbox
          field="internal"
          :disable="userClass.availableOnline"
          class="col-6"
          label="For Employees Only"
          bottom-slots
        />
      </div>
    </div>
  </model-form>
</template>

<script>

import ModelForm from 'src/modules/admin/components/ModelForm/ModelForm'

export default {
  name: 'UserClassForm',
  components: {
    ModelForm
  },
  models: {
    userClass: {
      registerType: 'default'
    }
  }
}

</script>
